import { render, staticRenderFns } from "./cModalProductionProduct.vue?vue&type=template&id=116db650&scoped=true"
import script from "./cModalProductionProduct.vue?vue&type=script&lang=js"
export * from "./cModalProductionProduct.vue?vue&type=script&lang=js"
import style0 from "./cModalProductionProduct.vue?vue&type=style&index=0&id=116db650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116db650",
  null
  
)

export default component.exports